import "../css/index.scss";
import AOS from "aos";
import "aos/dist/aos.css";

let mobileMenuBtn = document.getElementById("mobile-btn");
let navMenus = document.querySelector(".nav-menus");
let header = document.querySelector("header");

if (mobileMenuBtn) {
  mobileMenuBtn.addEventListener("click", () => {
    navMenus.classList.toggle("open");
    mobileMenuBtn.classList.toggle("open");
    header.classList.toggle("open");
  });
}

if (AOS) {
  AOS.init();
}

document.addEventListener("scroll", function () {
  var heroSection = document.querySelector(".rh-hero");
  var firstSection = document.querySelector(".rh-section");
  if (heroSection && firstSection) {
    var heroHeight = heroSection.offsetHeight;
    var scrollPosition = window.scrollY;

    if (scrollPosition >= heroHeight && heroHeight) {
      heroSection.style.opacity = "0";
    } else {
      heroSection.style.opacity = "1";
    }
  }
});
